import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Mobile menu item submenus functionality
        let $mobileFooterItems = $('.ic-footer-mobile-nav > li > a.dropdown-toggle');
        $mobileFooterItems.each(function() {
            let $dropdown     = $(this).siblings('ul.dropdown-menu');
            let $plus         = $(this).find('span.plus');
            $(this).click(function(e) {
                if (!$(this).parent().hasClass('no-submenu')) {
                    e.preventDefault();
                    $dropdown.toggleClass('open');
                    if ($plus.html() === '+') {
                        $plus.html('-');
                    } else {
                        $plus.html('+');
                    }
                }
            })
        });
    }
}